import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-appearance',
	templateUrl: './icon-appearance.component.svg',
})
export class IconAppearanceComponent {}
